<template lang="html">

  <section class="popup-seleccion row-center" v-if="!!listaEmpresas">

    <div class="contenedor-popup-seleccion" :style="ownstyle.popup">

      <div class="contenedor-texto">

        <h2>{{$t('login.selecciona_empresa')}}</h2>


        <template v-for="(empresa,key) in listaEmpresas">

          <div class="contenedor-input">
            <input type="radio" name="fecha" :id="empresa.idEmpresa" v-model="empresaid" :value="empresa.idEmpresa">
            <label :for="empresa.idEmpresa">{{empresa.nombre}}</label>
          </div>

        </template>

        
        <template v-if="$route.name != 'ficha_encuestas'">
          <button class="btn -solid-primary" @click="sendEmpresaSeleccionada(empresaid)">{{$t('login.acceder')}}</button>
        </template>
        <template v-else>
            <button class="btn -solid-primary" @click="sendEmpresaSeleccionadaEncuesta(empresaid)">{{$t('login.acceder')}}</button>
        </template>

      </div>

    </div>

  </section>

</template>

<script lang="js">

  import {mapGetters,mapActions} from 'vuex'

  import router from '@/router';

  export default  {
    name: 'popup-seleccion-empresa',
    data(){
      return{
        empresaid : ''
      }
    },
    computed :{
      ...mapGetters({
        colors : 'basicColors',
        style : 'getStyles',
        listaEmpresas : 'getListaEmpresas'
      }),
      ownstyle : function(){
        return {
          popup :{
            background: this.colors.white
          }
        }
      }
    },
    methods :{
      ...mapActions(['sendEmpresaSeleccionada','sendEmpresaSeleccionadaEncuesta']),
    }
  }
</script>

<style scoped lang="scss">

  .popup-seleccion {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,.5);
    z-index: 20;
    padding: 20px;
  }

  .contenedor-texto{
    width: 100%;
  }

  .contenedor-popup-seleccion{
    width: 100%;
    height: auto;
    display: inline-block;
    padding: 25px;
    max-width: 600px;
  }

  h2{
    text-align: left;
    font-size: 20px;
    margin-bottom: 20px;
  }

  .contenedor-input{
    margin-bottom: 0;
    padding-bottom: 0;

    &:last-of-type{
      margin-bottom: 20px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/views/login/popup-seleccion-empresa.vue